// 6) Clic descargar App
export const clicDescargarApp = (dataLayer, { idUsuario, nombreApp }) => {
	dataLayer?.push?.({
		'event': 'clic-descargar-app',
		'user-id': idUsuario,
		'ubicacion': nombreApp,
	})
}
